<div class="align-items-center card-header d-flex p-2 border w-100" (click)="show = !show">
  <i class="link" style="cursor: pointer" [class]="show ? 'fa fa-chevron-down mr-2' : 'fa fa-chevron-right mr-2'"></i>
  <label class="link font-weight-bold mb-0 w-100">{{ key.charAt(0).toUpperCase() + key.slice(1) }}</label>
  <span class="badge badge-dark text-light link" *ngIf="count(filterModel) > 0">
    {{ count(filterModel) }}
  </span>
</div>
<div class="p-2 border w-100" *ngIf="show" style="overflow-y: scroll; max-height: 250px; overflow-x: hidden; border-bottom: 1px solid #ccc">
  <div *ngFor="let data of filterModel; let i = index">
    <div *ngIf="data.count >= 1" class="hover:tw-bg-slate-50 w-100 tw-cursor-pointer">
      <label [attr.checked]="data.isSelected !== undefined ? data.isSelected : true" [attr.for]="data.name + '-' + i" class="tw-mb-0 tw-flex tw-items-center tw-justify-between tw-w-full">
				<input id="{{ data.name }}-{{ i }}" type="checkbox" [(ngModel)]="data.isSelected" (ngModelChange)="onFilterChange(filterModel)" class="mr-1"  /><span class="tw-w-full tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis">{{ data.name }}</span>
				<span [ngClass]="data.isSelected ? 'tw-bg-gray-600' : 'tw-bg-gray-200'" class="tw-ml-2 tw-text-white tw-text-xs tw-font-semibold tw-mr-2 tw-px-2.5 tw-py-0.5 tw-rounded-full tw-flex tw-items-center ">
					{{ data.count || 0 }}
				</span></label>
    </div>
  </div>
</div>
